import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { ToastService } from '../../_core/services/toast.service';
import { FeedbackService } from '../../feedback/feedback.service';
import { nextFriday } from 'date-fns';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { AuthService } from '../../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-request-event',
  templateUrl: './request-event.component.html',
  styleUrls: ['./request-event.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    IonicModule
  ]
})
export class RequestEventComponent {
  private modalController = inject(ModalController)
  private toastService = inject(ToastService)
  private feedbackService = inject(FeedbackService)
  private authService = inject(AuthService)
  private translateService = inject(TranslateService)

  form = new FormGroup({
    name: new FormControl('', { nonNullable: true, validators:[Validators.required] }),
    email: new FormControl('', { nonNullable: true, validators:[Validators.required, Validators.email] }),
    discipline: new FormControl('', { nonNullable: true, validators:[Validators.required] }),
    eventName: new FormControl('', { nonNullable: true, validators:[Validators.required] }),
    eventType: new FormControl('INDIVIDUAL', { nonNullable: true, validators:[Validators.required] }),
    startDate: new FormControl(nextFriday(new Date().setHours(12, 0, 0, 0)).toISOString(), { nonNullable: true, validators:[Validators.required] }),
    description: new FormControl('')
  })

  async submit() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.toastService.presentDangerToast(this.translateService.instant('Please enter information about your event'))
      return;
    }

    const description = `
      Name: ${this.form.controls.name.value},
      Email: ${this.form.controls.email.value},
      Sport: ${this.form.controls.discipline.value},
      Event name: ${this.form.controls.eventName.value},
      Event type: ${this.form.controls.eventType.value},
      Start date: ${this.form.controls.startDate.value},
      Description: ${this.form.controls.description.value},
    `;

    const feedback = {
      description: description,
      user: this.authService.authUserSignal()?._id,
      appVersion: await this.getAppVersion(),
      contactMethod: 'Website form',
      email: this.form.controls.email.value
    }

    this.feedbackService.create(feedback)
      .pipe()
      .subscribe(res => {
        this.toastService.presentToast(this.translateService.instant('Your request has been submited. We will be in touch with in the next 48h.'));
        this.close();
      })
  }

  async close() {
    await this.modalController.dismiss();
  }

  private async getAppVersion() {
    if (Capacitor.isNativePlatform()) {
      const info = await App.getInfo();
      return info.version;
    } else {
      return 'Browser';
    }
  }
}
